export const AUTH_URL = 'https://api.rheinwelten.app'
// export const AUTH_URL = 'http://localhost'
